import { useState, useEffect, useRef } from "react";
import { useRouter, withRouter } from "next/router";
import PropTypes from "prop-types";
import {
  Row,
  Col,
  Container,
  CustomContainer,
  useDispatch,
} from "../../components/atoms/DependencyHelper";
import ajaxservice from "../../utils/ajaxServices";
import { BannerDetails } from "../../config/queries";
import {
  resetData,
  getFilterProductList,
  parseFilterQuery,
  getProductList,
  getSortQuery,
  getProductsFilterByPageNumber,
  getFilteredCategories,
  getFilteredCategory,
  getProductsFilterBySort,
  getProductsFilterByPrice,
  getProductsFilterByRange,
  getProductsFilterByBrands,
  getProductsFilterByPromotions,
  resetMobileFilter,
  resetToPrice,
  getProductAggregations,
  getProductsFilterByCategory,
  getProductsFilterBySubCategory,
} from "../../services/filterService";
import { connect, useSelector } from "react-redux";
import { getAllCategories } from "../../services/productListService";
import {
  dynamicBreadCrumb,
  getCurrentPageNumber,
  updatePathInBreadCrumb,
  getCurrentSortVal,
  showSpinner,
  hideSpinner,
  formatBreadCrumb,
  updateSessionStorage,
} from "../../utils/helperServices";
import labels from "../../config/labels";
import {
  link as AnalyticsLink,
  getUtagData as AnalyticsGetUtagData,
  getProfileData as AnalyticsGetProfileData,
  view as AnalyticsView,
  setAutoTagging as AnalyticsSetAutoTagging
} from "../../services/analyticsUtag";
import * as pageAPI from "../../services/pageService";
import { renderComponent } from "../../services/renderComponent";
import dynamic from "next/dynamic";
import Seo from "../../components/atoms/Seo/Seo";
import { removeCompareProducts } from "../../Redux/actions/productCompareAction";
import config from "../../config";
import ErrorCard from "../../components/molecules/errorCard/ErrorCard";
import { breadcrumbGenerator } from "../../services/breadcrumbService";
import { ALERT_SELECT } from "../../Redux/actionTypes";
import types from "../../config/types";
import * as FIXED from "../../config/constants";
import AffordabilityFilterToggle from "../../components/organisms/AffordabilityFilterToggle/AffordabilityFilterToggle";
import {
  displayHideUpgradeModal,
  fetchCreditFilters,
  updateUpgradeRedirect,
  displayHideUpgradeTopbanner,
  updateProductGridReset,
} from "../../Redux/actions/upgradeAction";
import UpgradeCheckBar from "../../components/atoms/upgradeCheckBar/upgradeCheckBar";

import {
  getNotAllowedRanges,
  getPriceFilterDataFromOptions,
  getAffordablePriceFilterDataFromOptions,
} from "../../utils/priceFilterUtils";
import { toggleFilters } from "../../Redux/actions/navAction";
import configra from "../../config/index";
import { Router } from "../../components/atoms/DependencyHelper";
import { forceVisible } from "react-lazyload";
import PageBuilder from "components/pageBuilder/lib/pagebuilder";
import { getCategoryCMSContent } from "Redux/actions/pageBuilderActions";
// import { Logger } from "utils/logger";

const ProductRangeContainer = dynamic(
  import("../../components/molecules/product-range-section/productRange"),
  { ssr: false }
);
const k8sConfig = typeof window === "undefined" ? require("config") : "";
const SearchContainer = dynamic(
  import("../../components/organisms/SearchContainer/SearchContainer"),
  { ssr: false }
);
const BrowseContainer = dynamic(
  import("../../components/organisms/BrowseContainer/BrowseContainer"),
  { ssr: false }
);
const ProductListContainer = dynamic(
  import(
    "../../components/organisms/ProductListContainer/ProductListContainer"
  ),
  { ssr: false }
);
const StickyBottomContainer = dynamic(
  import("../../components/atoms/stickyBottomContainer/StickyBottomContainer"),
  { ssr: false }
);
const ButtonGroup = dynamic(
  import("../../components/molecules/buttonGroups/ButtonGroup")
);
const BreadCrumb = dynamic(
  import("../../components/atoms/breadCrumb/BreadCrumb"),
  { ssr: false }
);

const ProductListPage = (props) => {
  const dispatch = useDispatch();
  const router = useRouter();
  const categoryCmsContent = useSelector(state => state.pageBuilder.categoryCmsContent);
  const [cmsLoading, setCmsLoading] = useState(true);
  const [categoryCMS, setCategoryCMS] = useState();
  const [categoryDisplayMode, setCategoryDisplayMode] = useState();
  const [categoryName, setCategoryName] = useState();
  const dynamicRoute = dynamicBreadCrumb();
  const [showComp, setshowComp] = useState(false);
  const [viewExecuted, setViewExecuted] = useState(false);
  const [maxMonthlyPrice, setMaxPrice] = useState();
  const [priceValue, setPriceValue] = useState({});
  const [priceType, setPriceType] = useState("");
  const [priceReset, setPriceReset] = useState(false);
  const [sectionLvls, setSectionLvls] = useState({});
  const [showQualifyProducts, setShowQualifyProducts] = useState(false);
  const [isProductsUpgrade, setIsProductsUpgrade] = useState(false);
  const pageName = "shopping: devices: product grid";
  const productListLoaded = useRef(false);
  const aggregationsLoaded = useRef(false);
  let [productList, setProductList] = useState({});
  let [selectedFilter, setSelectedFilter] = useState(props.selectedFilter);
  let [selectedCategory, setSelectedCategory] = useState();
  const [allBrands, setAllBrands] = useState([]);
  const [allPromotions, setAllPromotions] = useState([]);
  const [bannerData, setBannerData] = useState("");
  let [sortProductsBy, setSortProductsBy] = useState(
    getCurrentSortVal(router.asPath, true)
  );
  let [featureSelected, setFeatureSelected] = useState("filter");
  let [filterWithSort, setFilterWithSort] = useState(false);
  let [_currentPage, setCurrentPage] = useState();
  let [isPageUpdated, setIsPageUpdated] = useState(false);
  const [renderdEmpty, setRenderdEmpty] = useState(false);
  const [analytics, setAnalytics] = useState(false);
  const [gridId, setGridId] = useState();
  const [categoryList, setCategoryList] = useState({});
  const [priceFilterData, setPriceFilterData] = useState({
    once: [],
    monthly: [],
  });
  const [missingPriceFilterData, setMissingPriceFilterData] = useState({
    once: [],
    monthly: [],
  });
  const [aggMaxPrice, setAggMaxPrice] = useState({
    once: 0,
    monthly: 0,
  });
  const [aggMinPrice, setAggMinPrice] = useState({
    once: 0,
    monthly: 0,
  });
  let [attributeFlag, setAttributeFlag] = useState(null);
  let [showProduct, setShowProducts] = useState(false);
  let [sections, setSections] = useState();
  let [seoMetaData, setSeoMetaData] = useState();
  let [_priceObj, setPriceObj] = useState({});
  let [affordablePriceRange, setAffordablePriceRange] = useState([]);
  let [missingAffordablePriceRange, setMissingAffordablePriceRange] = useState(
    []
  );
  let apiErrors = {
    isCategoryError: false,
    isProductError: false,
    isProductFetched: false,
    isBannerError: false,
    isBrandError: false,
  };
  let [errorType, setErrorType] = useState(apiErrors);
  const env = configra.env;
  const urlPrefix = configra.envConfigs[env].shoppingUrlPrefix;
  let joinAllData = (array) => {
    const newKeys = [].concat.apply([], array);
    const allkeys = newKeys.join(",");
    return allkeys;
  };
  const errorMessages = {
    heading: labels.errorMessages.lbl_page_error,
    subHeading1: labels.errorMessages.lbl_page_error_subheading1,
    subHeading2: labels.errorMessages.lbl_page_error_subheading2,
  };

  const getStatusFilter = (filter, disabled = false) => {
    return { ...filter, disabled };
  };

  const initAggregations = async () => {
    if (aggregationsLoaded.current) return;
    // find price aggregation
    if (priceFilterData?.once?.length == 0) {
      aggregationsLoaded.current = true;
      const products = await getProductAggregations({});
      const oncePriceAggregation = products?.products?.aggregations?.find(
        (agg) => agg.attribute_code === "price"
      );
      const monthlyPriceAggregation = products?.products?.aggregations?.find(
        (agg) => agg.attribute_code === "bundle_product_price"  || agg.attribute_code === "bundle_product_price_bucket"
      );
      const brandAggregation = products?.products?.aggregations?.find(
        (agg) => agg.attribute_code === "manufacturer"
      )?.options;
      const promotionAggregation = products?.products?.aggregations?.find(
        (agg) => agg.attribute_code === "promotion_tag"
      )?.options;
      if (oncePriceAggregation && monthlyPriceAggregation) {
        const onceValueRange = getPriceFilterDataFromOptions(
          oncePriceAggregation?.options ?? []
        );
        const monthlyValueRange = getPriceFilterDataFromOptions(
          monthlyPriceAggregation?.options ?? []
        );
        const onceMissingValueRange = getNotAllowedRanges(
          oncePriceAggregation?.options ?? []
        );
        const monthlyMissingValueRange = getNotAllowedRanges(
          monthlyPriceAggregation?.options ?? []
        );
        setAggMaxPrice({
          once: onceValueRange[onceValueRange?.length - 1] || FIXED.MAX_ONCE_OF,
          monthly:
            monthlyValueRange[monthlyValueRange?.length - 1] ||
            FIXED.MAX_MONTHLY_RECURRING,
        });
        setAggMinPrice({
          once: onceValueRange[0] || 0,
          monthly: monthlyValueRange[0] || 0,
        });
        setPriceFilterData({
          once: onceValueRange,
          monthly: monthlyValueRange,
        });
        setMissingPriceFilterData({
          once: onceMissingValueRange,
          monthly: monthlyMissingValueRange,
        });
      }
      updateFilters({ brandAggregation, promotionAggregation });
    }
  };

  const updateFilters = ({
    brandAggregation = [],
    promotionAggregation = [],
  }) => {
    if (brandAggregation?.length) {
      if (allBrands.length) {
        setAllBrands(
          allBrands.map((brand) => {
            if (
              brandAggregation.findIndex(
                (newBrand) => newBrand.value === brand.value
              ) > -1
            ) {
              return { ...brand, disabled: false };
            } else {
              return { ...brand, disabled: true };
            }
          })
        );
      } else {
        setAllBrands(brandAggregation?.map((brand) => getStatusFilter(brand)));
      }
    } else {
      if (allBrands.length) {
        setAllBrands(allBrands?.map((brand) => getStatusFilter(brand, true)));
      } else {
        errorType.isBrandError = true;
        setErrorType(errorType);
      }
    }
    if (promotionAggregation?.length) {
      if (allPromotions.length) {
        setAllPromotions(
          allPromotions.map((promotion) => {
            if (
              promotionAggregation.findIndex(
                (newPromotion) => newPromotion.value === promotion.value
              ) > -1
            ) {
              return { ...promotion, disabled: false };
            } else {
              return { ...promotion, disabled: true };
            }
          })
        );
      } else {
        setAllPromotions(
          promotionAggregation?.map((promotion) => getStatusFilter(promotion))
        );
      }
    } else {
      setAllPromotions(
        allPromotions?.map((promotion) => getStatusFilter(promotion, true))
      );
    }
  };

  const updateAggregations = async ({ minPrice, maxPrice, type, endType }) => {
    if (maxPrice || endType == "range") {
      const products = await getProductAggregations({
        selectedFilter,
        maxPrice,
        type,
        minPrice,
      });
      const brandAggregation = products?.products?.aggregations?.find(
        (agg) => agg.attribute_code === "manufacturer"
      )?.options;
      const promotionAggregation = products?.products?.aggregations?.find(
        (agg) => agg.attribute_code === "promotion_tag"
      )?.options;
      updateFilters({ brandAggregation, promotionAggregation });
    }
  };

  const initAggregationsMaxPrice = async (maxPriceValue, type) => {
    // find price aggregation for affordability
    if (maxPriceValue) {
      const products = await getProductAggregations({
        selectedFilter,
        maxPrice: maxPriceValue,
        type,
      });

      const monthlyPriceAggregation = products?.products?.aggregations?.find(
        (agg) => agg.attribute_code === "bundle_product_price"  || "bundle_product_price_bucket"
      );
      const brandAggregation = products?.products?.aggregations?.find(
        (agg) => agg.attribute_code === "manufacturer"
      )?.options;
      const promotionAggregation = products?.products?.aggregations?.find(
        (agg) => agg.attribute_code === "promotion_tag"
      )?.options;

      if (monthlyPriceAggregation) {
        const monthlyValueRange = getPriceFilterDataFromOptions(
          monthlyPriceAggregation?.options ?? []
        );

        const monthlyMissingValueRange = getNotAllowedRanges(
          monthlyPriceAggregation?.options ?? []
        );
        const affordablePriceFilterData =
          getAffordablePriceFilterDataFromOptions(
            monthlyValueRange,
            Number(maxPriceValue),
            aggMaxPrice.monthly
          );
        setAffordablePriceRange(affordablePriceFilterData);
        setMissingAffordablePriceRange(monthlyMissingValueRange);
      }
      updateFilters({ brandAggregation, promotionAggregation });
    }
  };

  const reloadPageData = () => {
    showSpinner();
    setIsPageUpdated(true);
  };

  const isMonthly = () => priceType === types.TYPE_MONTHLY;
  const isOnceOff = () => !priceType || priceType === types.TYPE_ONCE_OFF;

  const setMaxMonthlyPrice = (value) => {
    setPriceValue({
      minValue: aggMinPrice.monthly,
      maxValue: value,
    });
    setMaxPrice(value);
  };

  const switchPriceToOnceOff = () => {
    setPriceType(types.TYPE_ONCE_OFF);
    setPriceValue({
      minValue: aggMinPrice.once,
      maxValue: aggMaxPrice.once,
    });
    setMaxPrice(aggMaxPrice.once);
  };

  const switchPriceToMonthly = () => {
    setPriceType(types.TYPE_MONTHLY);
    setPriceValue({
      minValue: aggMinPrice.monthly,
      maxValue: aggMaxPrice.monthly,
    });
    setMaxPrice(aggMaxPrice.monthly);
  };

  const handlePriceTypeChange = (type) => {
    let { maxValue, minValue } = getPriceType(type);
    getProductsFilterByPrice({
      minValue,
      maxValue,
      type,
      isShowQualifying: "false",
      skipPageNumber: true,
    }).then(reloadPageData);
  };

  const getPriceType = (type) => {
    let maxValue;
    let minValue;
    if (type === types.TYPE_MONTHLY) {
      switchPriceToMonthly();
      minValue = aggMinPrice.monthly;
      maxValue = aggMaxPrice.monthly;
    } else {
      switchPriceToOnceOff();
      minValue = aggMinPrice.once;
      maxValue = aggMaxPrice.once;
    }
    setShowQualifyProducts(false);
    return { maxValue, minValue };
  };

  const handlePriceChange = (value, priceType) => {
    getSelectedPrice(value, priceType);
    getProductsFilterByPrice({
      minValue: value.min,
      maxValue: value.max,
      type: priceType,
      isShowQualifying: showQualifyProducts ? "true" : "false",
    }).then(reloadPageData);
  };

  const getSelectedPrice = (value, priceType) => {
    if (priceType) {
      setPriceType(priceType);
    } else {
      priceType =
        maxMonthlyPrice < aggMaxPrice.monthly
          ? types.TYPE_MONTHLY
          : types.TYPE_ONCE_OFF;
      setPriceType(priceType);
    }
    setPriceValue({
      minValue: value.min,
      maxValue: value.max,
    });
    setPriceObj({
      type: priceType,
      min: value.min,
      max: value.max,
    });

    AnalyticsLink({
      ...AnalyticsGetUtagData(),
      page_tool_event: "use",
      page_tool_name: "shopping: product grid: price filter",
      filter_query: `${priceType},${value.min || 0},${value.max || 100000}`,
      page_name: "shopping: devices: product grid",
      page_channel: "shopping",
    });
  };

  const handleBrandChange = (flag, value) => {
    let brandArr = getSelectedBrands(flag, value);
    getProductsFilterByBrands(brandArr).then(reloadPageData);
  };

  const getSelectedBrands = (flag, value) => {
    let brandArr = selectedFilter?.brands ? [...selectedFilter?.brands] : [];
    if (flag) {
      brandArr.filter((brand) => brand.label === value.label).length === 0
        ? brandArr.push(value)
        : brandArr;
    } else {
      brandArr.filter((brand, index) => {
        if (brand.label === value.label) {
          brandArr.splice(index, 1);
        }
      });
    }
    setSelectedFilter({
      ...selectedFilter,
      ...{ brands: brandArr },
    });
    const selectedBrands = brandArr.map((brand) => brand.label);

    AnalyticsLink({
      ...AnalyticsGetUtagData(),
      page_tool_event: "use",
      page_tool_name: "shopping: product grid: brand filter",
      filter_query: selectedBrands.toString(),
      page_name: "shopping: devices: product grid",
      page_channel: "shopping",
    });
    return brandArr;
  };

  const handlePromotionChange = (flag, value) => {
    let promotionArr = getSelectedPromotion(flag, value);
    getProductsFilterByPromotions(promotionArr).then(reloadPageData);
  };

  const getSelectedPromotion = (flag, value) => {
    let promotionArr = selectedFilter?.promotions
      ? [...selectedFilter?.promotions]
      : [];
    if (flag) {
      promotionArr.filter((promotion) => promotion.label === value.label)
        .length === 0
        ? promotionArr.push(value)
        : promotionArr;
    } else {
      promotionArr.filter((promotion, index) => {
        if (promotion.label === value.label) {
          promotionArr.splice(index, 1);
        }
      });
    }
    setSelectedFilter({
      ...selectedFilter,
      ...{ promotions: promotionArr },
    });
    AnalyticsLink({
      ...AnalyticsGetUtagData(),
      page_tool_event: "use",
      page_tool_name: "shopping: product grid: promotions filter",
      filter_query: value.label,
      page_name: "shopping: devices: product grid",
      page_channel: "shopping",
    });
    return promotionArr;
  };

  const handleSelectedCategory = (categoryId) => {
    const tempSelectedFilter = { ...selectedFilter };
    for (const key in tempSelectedFilter) {
      if (
        key != "updateFilterCriteria" &&
        key != "isShowQualifying" &&
        key != "monthlyPrice"
      ) {
        delete tempSelectedFilter[key];
      }
    }

    if (!categoryId) {
      setSelectedFilter(...tempSelectedFilter);
    } else {
      setSelectedFilter({
        ...tempSelectedFilter,
        ...{ selectedCategory: categoryId },
      });
    }
  };

  const handleApplyFilter = (newSelectedFilters = selectedFilter || {}) => {
    const { brands, promotions, selectedCategory, selectedSubCategory } =
      newSelectedFilters;

    const { minValue, maxValue } = priceValue || {};
    let filterHref = "";
    let str = "";
    if (selectedCategory) {
      str = getProductsFilterByCategory(selectedCategory, true); //true-return href, false-router push
      if (str && str !== "") {
        filterHref += str;
      }
    }
    if (selectedSubCategory) {
      str = getProductsFilterBySubCategory(selectedSubCategory, true); //true-return href, false-router push
      if (str && str !== "") {
        filterHref += filterHref == "" ? str : `&${str}`;
      }
    }
    if (brands) {
      str = getProductsFilterByBrands(brands, true); //true-return href, false-router push
      if (str && str !== "") {
        filterHref += filterHref == "" ? str : `&${str}`;
      }
    }

    if (promotions) {
      str = getProductsFilterByPromotions(promotions, true);
      if (str && str !== "") {
        filterHref += filterHref == "" ? str : `&${str}`;
      }
    }
    if (Object.keys(priceValue).length !== 0) {
      let priceObj = {
        type: priceType || types.TYPE_ONCE_OFF,
        minValue: minValue,
        maxValue: maxValue,
        isShowQualifying: showQualifyProducts,
        skipPageNumber: true,
      };
      str = getProductsFilterByPrice(priceObj, true);
      if (str && str !== "") {
        filterHref += filterHref == "" ? str : `&${str}`;
      }
    }
    if (filterHref !== "") {
      const newHref = filterHref
        ? `${urlPrefix}/products?${filterHref}`
        : `${urlPrefix}/products`;
      Router.push(`${urlPrefix}/products`, newHref, { shallow: true }).then(
        reloadPageData
      );
    }
  };

  const isEligible = () => {
    return (
      props?.upgrade?.upgradeCheckDone &&
      props?.upgrade?.upgradeResponse?.upgradeEligible
    );
  };

  const handleResetFilter = (type, fullReset) => {
    if (fullReset) {
      /* filter full reset */
      if (isEligible()) {
        /* if upgrade in progress */
        setMaxMonthlyPrice(getMaxPrice());
        setShowQualifyProducts(true);
        setPriceType(types.TYPE_MONTHLY);
        return resetToPrice(
          "monthlyPrice",
          aggMinPrice.monthly,
          getMaxPrice(),
          router
        ).then(reloadPageData);
      }
      /* default case */
      switchPriceToOnceOff();
      setPriceType("");
      return resetMobileFilter().then(reloadPageData);
    }
    if (type === "price") {
      /* price filter reset */
      if (isEligible()) {
        /* if upgrade in progress */
        const eliMaxPrice = getMaxPrice();
        setMaxMonthlyPrice(eliMaxPrice);
        setShowQualifyProducts(true);
        setPriceType(types.TYPE_MONTHLY);
        return getProductsFilterByPrice({
          minValue: aggMinPrice.monthly,
          maxValue: eliMaxPrice, // FIXED.MAX_MONTHLY_RECURRING,
          type: types.TYPE_MONTHLY,
          isShowQualifying: "true",
        }).then(reloadPageData);
      }
      setPriceReset(true);
      switchPriceToOnceOff();
      const dataType =
        priceType === types.TYPE_MONTHLY ? "monthlyPrice" : "price";
      setPriceType("");
      resetData(dataType, selectedFilter, router).then(reloadPageData);
    }
  };

  const getBannerAttributesForCategory = async () => {
    setGridId(props.id);
  };

  const getPromotionData = async () => {
    const promotionData = await pageAPI.getPageComponents([
      `products/CBU${
        props?.previewMode
          ? config.pageServiceQueryData.preview
          : config.pageServiceQueryData.status
      }`,
    ]);
    setSections(promotionData?.sections || []);
    setSeoMetaData(promotionData?.seoMetadata || {});
    if (promotionData && promotionData.status === "error") {
      AnalyticsLink({
        page_name: pageName,
        page_form_event: "error",
        page_errors: `${promotionData.reason ? promotionData.reason : ""}`,
        page_errors_code: `plp-d-g-seo`,
      });
    }
  };

  const getCategoryGridData = async () => {
    try {
      const categoryList = await getAllCategories(
        false,
        props?.defaultCategoryId,
        props?.dealCategoryId
      );
      if (categoryList && categoryList.categories?.length === 0) {
        errorType.isCategoryError = true;
        setErrorType(errorType);
      } else {
        setCategoryList(categoryList);
        errorType.isCategoryError = false;
        setErrorType(errorType);
        setShowProducts(true);
      }
      if (categoryList && categoryList.errors) {
        AnalyticsLink({
          page_name: pageName,
          page_form_event: "error",
          page_errors: `${
            categoryList.errors[0] ? categoryList.errors?.[0].message : ""
          }`,
          page_errors_code: `plp-dxl-g-ac-${categoryList.status}`,
        });
      }
    } catch (error) {
      errorType.isCategoryError = true;
      setErrorType(errorType);
    } finally {
      hideSpinner();
    }
  };

  const isFilterApplied = async (sortParam) => {
    showSpinner();
    setShowProducts(false);
    try {
      let filter = await parseFilterQuery(
        decodeURIComponent(window.location.search)
      );
      if (
        showQualifyProducts &&
        props?.upgrade?.creditFilters?.financeIndicator === "N"
      ) {
        filter.deviceInstallment = Number(
          props?.upgrade?.creditFilters?.deviceInstallment
        );
      }
      if (filter?.monthlyPrice || filter?.price) {
        const { minValue, maxValue } = filter?.price || filter?.monthlyPrice;
        setPriceValue({
          minValue: (minValue && Number(minValue)) || 0,
          maxValue: Number(maxValue),
        });
        const priceType = filter?.monthlyPrice
          ? types.TYPE_MONTHLY
          : types.TYPE_ONCE_OFF;
        setPriceType(priceType);
      } else {
        setPriceType("");
      }
      if (
        JSON.stringify(filter) != JSON.stringify(selectedFilter) ||
        filterWithSort ||
        isPageUpdated
      ) {
        productListLoaded.current = false;
        setSelectedFilter((selectedFilter = filter));
        if (!filter?.monthlyPrice && !filter?.price) {
          setPriceObj({});
        }
        if (!isEligible() && (filter?.monthlyPrice || filter?.price)) {
          const { minValue, maxValue } = filter?.price || filter?.monthlyPrice;
          setPriceValue({
            minValue: (minValue && Number(minValue)) || 0,
            maxValue: Number(maxValue),
          });
          if (selectedFilter?.monthlyPrice) {
            setPriceType(types.TYPE_MONTHLY);
            setMaxPrice(aggMaxPrice.monthly);
          }
          if (selectedFilter?.price) {
            if (!priceReset) setPriceType(types.TYPE_ONCE_OFF);
            else setPriceType("");
            setMaxPrice(aggMaxPrice.once);
          }
        }
        if (
          !isEligible() &&
          !(selectedFilter?.monthlyPrice || selectedFilter?.price)
        ) {
          setMaxMonthlyPrice(aggMaxPrice.once);
        }

        setPriceReset(false);
      }
      if (selectedFilter && typeof selectedFilter === 'object' && Object.keys(selectedFilter) && !productListLoaded.current) {
        productListLoaded.current = true;
        productList = await getFilterProductList(
          filter,
          sortParam,
          getCurrentPageNumber(router.asPath)
        );
        setProductList(productList ? productList : {});
        if (productList && productList.errors) {
          AnalyticsLink({
            page_name: pageName,
            page_form_event: "error",
            page_errors: `${
              productList.errors[0] ? productList.errors?.[0].message : ""
            }`,
            page_errors_code: `plp-m-g-fp-${productList.status}`,
          });
        }
      } else {
        productListLoaded.current = true;
        productList = await getProductList(
          filter,
          sortParam,
          getCurrentPageNumber(router.asPath)
        );
        setProductList(productList ? productList : {});
        if (productList && productList.errors) {
          AnalyticsLink({
            page_name: pageName,
            page_form_event: "error",
            page_errors: `${
              productList.errors[0] ? productList.errors?.[0].message : ""
            }`,
            page_errors_code: `plp-m-g-p-${productList.status}`,
          });
        }
      }
      setFilterWithSort(false);
      await getPromotionData();
      errorType.isProductError =
        productList && productList.products ? false : true;
      errorType.isProductFetched =
        productList && productList.products ? true : false;
      setErrorType(errorType);
    } catch (error) {
      errorType.isProductError = true;
      setErrorType(errorType);
    } finally {
      if (attributeFlag === null || attributeFlag !== true) {
        await getBannerAttributesForCategory();
        setAttributeFlag(true);
      }

      if (Object.keys(categoryList).length === 0 || errorType.isCategoryError) {
        await getCategoryGridData();
      }
      errorType.isProductFetched = true;
      setErrorType(errorType);
      setShowProducts(true);
      hideSpinner();
    }
  };

  const loadProducts = () => {
    showSpinner();
    setIsPageUpdated(false);
    const sortFromRoute = getCurrentSortVal(router.asPath, true);
    const sortParam = getSortQuery(sortFromRoute);
    setSortProductsBy(sortFromRoute);
    updatePathInBreadCrumb(router);
    isFilterApplied(sortParam);
  };

  useEffect(() => {
    loadProducts();
  }, [router.query, router.pathname]);

  useEffect(() => {
    initAggregations();
    dispatch({ type: ALERT_SELECT, payload: false });
    AnalyticsSetAutoTagging(false);
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    props.toggleFilters(false);
  }, []);

  useEffect(() => {
    if (showProduct) {
      setErrorType(errorType);
    }
  }, [showProduct]);

  useEffect(() => {
    const selectedPromotionsData =
      selectedFilter?.promotions?.map((item) => item.value) || [];
    const selectedBrandsData =
      selectedFilter?.brands?.map((item) => item.value) || [];
    async function getBannerData() {
      const bannerResult = await ajaxservice.fetchGraphQLGetRequest(
        BannerDetails,
        {
          grid: gridId,
          brand: `${joinAllData(selectedBrandsData)}`,
          promotion: `${joinAllData(selectedPromotionsData)}`,
        }
      );
      if (bannerResult) {
        setBannerData(bannerResult?.banners || []);
        if (bannerResult.errors) {
          AnalyticsLink({
            page_name: pageName,
            page_form_event: "error",
            page_errors: `${
              bannerResult.errors[0] ? bannerResult.errors?.[0].message : ""
            }`,
            page_errors_code: `dlp-m-g-bd-${bannerResult.status}`,
          });
        }
      }
    }

    if (gridId) {
      if (selectedBrandsData?.length > 1) {
        setBannerData([]);
      } else {
        getBannerData();
      }
    }
  }, [selectedFilter?.promotions, selectedFilter?.brands, gridId]);

  const toggleHandler = (btnClicked) => {
    setFeatureSelected(btnClicked);
    setshowComp(!showComp);
    props.toggleFilters(true);
  };

  const changeState = () => {
    setshowComp(!showComp);
  };
  const breadcrumbs = breadcrumbGenerator().productlist.reverse();
  useEffect(() => {
    if (
      Object.keys(dynamicRoute).length &&
      !viewExecuted &&
      !props.profileLoading
    ) {
      if (!analytics) {
        const section_lvls = {};
        let index = 0;
        for (let item of breadcrumbs) {
          index = index + 1;
          if (index > 4) break;
          section_lvls[`page_site_section_lvl_${index}`] = item.label;
        }
        const userMetaData = AnalyticsGetProfileData(
          props.userLoggedIn,
          props.profileData
        );
        AnalyticsView({
          page_event: "view",
          page_name: pageName,
          page_channel: "shopping",
          channel_type: "Monthly",
          page_master_tab: "personal",
          ...section_lvls,
          ...userMetaData,
        });
        setViewExecuted(true);
        setSectionLvls(section_lvls);
        setAnalytics(true);
      }
    }
  }, [
    dynamicRoute,
    props.profileLoading,
    props.userLoggedIn,
    props.profileData,
  ]);

  useEffect(() => {
    if (
      productList &&
      productList.products &&
      productList.products.items &&
      productList.products.items.length > 0
    ) {
      setRenderdEmpty(false);
    } else {
      if (
        !renderdEmpty &&
        productList &&
        productList.products &&
        productList.products.total_count == 0
      ) {
        AnalyticsLink({
          page_name: pageName,
          page_form_event: "error",
          page_errors:
            "We couldn't find any results for your selected filters. Try widen your search by changing some of your selections, or reset all filters below.",
          page_channel: "shopping",
          page_master_tab: "personal",
          ...sectionLvls,
        });
        setRenderdEmpty(true);
      }
    }
  }, [productList?.products]);

  const sortBy = async (val) => {
    setSortProductsBy(val);
    setFilterWithSort(true);
    getProductsFilterBySort(val).then(reloadPageData);
  };

  const updateCurrentPage = (page) => {
    getProductsFilterByPageNumber(page).then(() => {
      setSelectedFilter({
        ...selectedFilter,
        ...{ currentPage: page },
      });
      setCurrentPage(page);
      reloadPageData();
      scrollTo(0, 0);
    });
  };

  const filteredCategory = getFilteredCategory(selectedFilter, categoryList);
  const filteredCategories = getFilteredCategories(
    selectedFilter,
    categoryList
  );

  useEffect(() => {
    if (isPageUpdated) {
      loadProducts();
      //This will create the ListPageRouterWithFilters session variable
      //that will be used by pages such as shopping/product-compare for redirection
      let temparray = [
        {
          products: decodeURI(router.asPath),
        },
      ];
      updateSessionStorage(
        labels.Session_Keys.lbl_list_page_router_with_filters,
        temparray
      );
      setTimeout(forceVisible, 1000);
    }
  }, [isPageUpdated]);

  const handleRangeChange = (val) => {
    let curRange = Number(val);
    const total = categoryList.categories ? categoryList.categories.length : 0;
    for (let i = 0; i < total; i++) {
      if (curRange === Number(categoryList.categories[i].id)) {
        if (Number(selectedCategory?.id) === curRange) {
          curRange = null;
        }

        AnalyticsLink({
          page_tool_event: "use",
          page_tool_name: "shopping: product grid: product range filter",
          page_name: pageName,
          filter_query: `${categoryList.categories[i].name}`,
          ...sectionLvls,
          ...AnalyticsGetUtagData([
            "page_channel",
            "channel_type",
            "page_master_tab",
            "visitor_login_status",
            "visitor_msisdn_hash",
            "visitor_customer_id",
            "visitor_id_hash",
            "visitor_subscription_type",
          ]),
        });
        break;
      }
    }
    setSelectedFilter({
      ...selectedFilter,
      ...{ selectedCategory: curRange },
    });
    getProductsFilterByRange(curRange).then(reloadPageData);
  };

  useEffect(() => {
    const curCategoryId =
      selectedFilter?.selectedCategory || selectedFilter?.selectedProductRange;
    if (categoryList && curCategoryId) {
      categoryList?.categories?.map((category) => {
        if (Number(category.id) === Number(curCategoryId)) {
          setSelectedCategory((selectedCategory = category));
        }
      });
    } else {
      setSelectedCategory((selectedCategory = null));
    }
  }, [
    categoryList,
    selectedFilter?.selectedCategory,
    selectedFilter?.selectedProductRange,
  ]);

  const getMaxPrice = () => {
    if (isEligible()) {
      if (props?.upgrade?.creditFilters?.financeIndicator) {
        const total_monthly_payment =
          Number(props?.upgrade?.creditFilters?.total_monthly_payment) || 0;
        if (total_monthly_payment > aggMaxPrice.monthly) {
          return aggMaxPrice.monthly;
        } else {
          return total_monthly_payment.toFixed();
        }
      } else {
        return aggMaxPrice.monthly;
      }
    } else {
      if (isMonthly()) {
        return aggMaxPrice.monthly;
      } else {
        return aggMaxPrice.once;
      }
    }
  };

  // Upgrade Affordability methods
  useEffect(() => {
    const asPath = window.location.search;
    const newMaxPrice = getMaxPrice();
    let curPriceMinValue = 0;
    let curPriceMaxValue = newMaxPrice;
    if (curPriceMaxValue) {
      parseFilterQuery(decodeURIComponent(asPath)).then((filterData) => {
        setSelectedFilter(filterData);
        if (isEligible() && !asPath.includes("isShowQualifying=false")) {
          if (filterData?.monthlyPrice) {
            curPriceMinValue = filterData?.monthlyPrice?.minValue || 0;
            curPriceMaxValue =
              filterData?.monthlyPrice?.maxValue || newMaxPrice;
          }
          initAggregationsMaxPrice(
            props?.upgrade?.creditFilters?.total_monthly_payment,
            types.TYPE_MONTHLY
          );
          setIsProductsUpgrade(true);
          setShowQualifyProducts(true);
          setPriceType(types.TYPE_MONTHLY);
          setMaxMonthlyPrice(newMaxPrice);
          setPriceValue({
            minValue: curPriceMinValue,
            maxValue: curPriceMaxValue,
          });
          getProductsFilterByPrice({
            minValue: curPriceMinValue,
            maxValue: curPriceMaxValue,
            type: types.TYPE_MONTHLY,
            isShowQualifying: "true",
          }).then(reloadPageData);
        } else {
          const isNotShowQualifying = router.asPath.includes(
            "isShowQualifying=false"
          );

          if (isEligible() && affordablePriceRange.length == 0) {
            initAggregationsMaxPrice(
              props?.upgrade?.creditFilters?.total_monthly_payment,
              types.TYPE_MONTHLY
            );
          }
          if (!isEligible() && filterData?.isShowQualifying == "true") {
            return resetMobileFilter().then(reloadPageData);
          } else if (
            (isProductsUpgrade || isNotShowQualifying) &&
            (filterData?.monthlyPrice || filterData?.price)
          ) {
            /* get back */
            setShowQualifyProducts(false);
            setIsProductsUpgrade(false);
            setPriceType("");
            let curMaxPrice = newMaxPrice;
            let curPriceType = types.TYPE_ONCE_OFF;
            if (filterData?.monthlyPrice) {
              curMaxPrice = aggMaxPrice.monthly;
              setPriceType(types.TYPE_MONTHLY);
              curPriceType = types.TYPE_MONTHLY;
              curPriceMinValue =
                filterData?.monthlyPrice?.minValue || aggMinPrice.monthly;
              curPriceMaxValue =
                filterData?.monthlyPrice?.maxValue || curMaxPrice;
            }
            if (filterData?.price) {
              curMaxPrice = aggMaxPrice.once;
              setPriceType(types.TYPE_ONCE_OFF);
              curPriceMinValue =
                filterData?.price?.minValue || aggMinPrice.once;
              curPriceMaxValue = filterData?.price?.maxValue || curMaxPrice;
            }
            setMaxPrice(curMaxPrice);
            setPriceValue({
              minValue: curPriceMinValue,
              maxValue: curPriceMaxValue,
            });
            getProductsFilterByPrice({
              minValue: curPriceMinValue,
              maxValue: curPriceMaxValue,
              type: curPriceType,
              isShowQualifying: "false",
            }).then(reloadPageData);
          } else {
            // loadProducts();
            setIsPageUpdated(true);
          }
        }
      });
    }
  }, [
    props.upgrade?.upgradeCheckDone,
    props.upgrade?.upgradeResponse,
    props.upgrade?.selectedUpgradeResponse,
    props.upgrade?.creditFilter?.financeIndicator,
    props?.userLoggedIn,
    // aggMaxPrice,
    priceFilterData,
  ]);

  const onBackButtonClick = () => {
    if (!isPageUpdated) setIsPageUpdated(true);
  };
  useEffect(() => {
    window.addEventListener("popstate", onBackButtonClick);
    return () => {
      window.removeEventListener("popstate", onBackButtonClick);
    };
  }, []);

  const handleShowQualifyProducts = (flag) => {
    if (!flag) {
      AnalyticsLink({
        page_name: pageName,
        page_tool_event: "use",
        page_tool_name: `${pageName}: deselect products I qualify for`,
      });
      switchPriceToMonthly();
      getProductsFilterByPrice({
        minValue: aggMinPrice.monthly,
        maxValue: aggMaxPrice.monthly,
        type: types.TYPE_MONTHLY,
        isShowQualifying: "false",
      }).then(reloadPageData);
    } else {
      AnalyticsLink({
        page_name: pageName,
        page_tool_event: "use",
        page_tool_name: `${pageName}: select products I qualify for`,
      });
      if (affordablePriceRange.length == 0) {
        initAggregationsMaxPrice(
          props?.upgrade?.creditFilters?.total_monthly_payment,
          types.TYPE_MONTHLY
        );
      }
      const newMaxPrice = getMaxPrice();
      setPriceType(types.TYPE_MONTHLY);
      setMaxMonthlyPrice(newMaxPrice);
      getProductsFilterByPrice({
        minValue: affordablePriceRange.length
          ? affordablePriceRange[0]
          : aggMinPrice?.monthly,
        maxValue: newMaxPrice,
        type:
          Number(newMaxPrice) === aggMaxPrice.once
            ? types.TYPE_ONCE_OFF
            : types.TYPE_MONTHLY,
        isShowQualifying: "true",
        skipPageNumber: true,
      }).then(reloadPageData);
    }
    setShowQualifyProducts(flag);
  };

  useEffect(() => {
    props.displayHideUpgradeTopbanner(!showComp);
  }, [showComp]);

  //END:  Upgrade Affordability methods
  let pageHeading =
    filteredCategory && filteredCategory?.name
      ? filteredCategory.name
      : labels.lbl_browse_all_prods;
  if (isEligible() && showQualifyProducts) {
    pageHeading = labels.upgrade.lbl_products_qualify;
  }

  const getValueRange = () => {
    // TO DO cater for credit filter

    if (isEligible() && showQualifyProducts) {
      return affordablePriceRange;
    } else {
      return priceType && priceType === types.TYPE_MONTHLY
        ? priceFilterData.monthly
        : priceFilterData.once;
    }
    // return priceType && priceType === types.TYPE_MONTHLY
    //   ? priceFilterData.monthly
    //   : priceFilterData.once;
  };

  const getMissingValueRange = () => {
    if (isEligible() && showQualifyProducts) {
      return missingAffordablePriceRange;
    } else {
      return priceType && priceType === types.TYPE_MONTHLY
        ? missingPriceFilterData.monthly
        : missingPriceFilterData.once;
    }
  };

  const getSelectedPriceFilter = () => {
    if (selectedFilter?.monthlyPrice) {
      return Number(priceValue?.minValue) > Number(aggMinPrice.monthly) ||
        Number(priceValue?.maxValue) < Number(aggMaxPrice.monthly)
        ? selectedFilter?.monthlyPrice
        : null;
    } else if (selectedFilter?.price) {
      return Number(priceValue?.minValue) > Number(aggMinPrice.once) ||
        Number(priceValue?.maxValue) < Number(aggMaxPrice.once)
        ? selectedFilter?.price
        : null;
    }
    return null;
  };

  useEffect(() => {
    const curCategoryId =
      selectedFilter?.selectedCategory || selectedFilter?.selectedProductRange;

    if (priceType && priceValue?.maxValue && allBrands?.length) {
      updateAggregations({
        type: priceType,
        minPrice: priceValue.minValue,
        maxPrice: priceValue.maxValue,
      });
    } else if (curCategoryId && priceValue?.maxValue && allBrands?.length) {
      updateAggregations({
        minPrice: priceValue.minValue,
        maxPrice: priceValue.maxValue,
        endType: "range",
      });
    }
  }, [
    priceType,
    priceValue,
    selectedFilter?.selectedCategory,
    selectedFilter?.selectedProductRange,
  ]);

  useEffect(() => {
    const query = new URLSearchParams(window.location.search);
    const categoryId = query.get('range') || query.get('category');
    if (!categoryId) {
      setCmsLoading(false)
      return
    }

    if (categoryId) dispatch(getCategoryCMSContent(categoryId));
    if (categoryCmsContent?.[categoryId]) {
        setCategoryCMS(categoryCmsContent[categoryId]?.content);
        setCategoryDisplayMode(categoryCmsContent[categoryId]?.displayMode);
        setCategoryName(categoryCmsContent[categoryId]?.name);

        if (!analytics && !viewExecuted && !cmsLoading) {
          AnalyticsView({
            page_event: "view",
            page_name: `shopping: ${categoryCmsContent[categoryId]?.name}`,
            ...AnalyticsGetUtagData([
              "page_channel",
              "page_master_tab",
              "visitor_login_status",
              "visitor_customer_id",
              "visitor_id_hash",
              "visitor_msisdn_hash",
              "visitor_subscription_type"
            ]),
          });
          setViewExecuted(true);
          setAnalytics(true);
        }

        setCmsLoading(false)
    } else if (categoryCmsContent) {
        setCmsLoading(false)
    }
  }, [categoryCmsContent, router.query]);

  return (
    <>
      <Seo
        title={seoMetaData?.title}
        content={seoMetaData?.description}
        url={seoMetaData?.canonical_url}
        keywords={seoMetaData?.keywords}
        robots={seoMetaData?.robots}
      />
      {/* {
  errorType && (errorType?.isCategoryError || errorType?.isProductError || errorType?.isBrandError) ? (
    <div className="error-tooltip">
      {" "}
      <ErrorTooltip errorMsg={labels.lbl_error_block_API_fail} />{" "}
    </div>
  ) : ''} */}

      <CustomContainer id="product-list-container" className="main-container">
        <Container className="custom-container">
          {/* {errorType &&
					(errorType ?.isCategoryError || errorType ?.isProductError || errorType?.isBrandError) ? < ></>: */}
          <Row>
            <Col md={12} className={showComp ? "hide" : ""}>
              <BreadCrumb
                list={categoryDisplayMode === "PAGE" && categoryName
                  ? formatBreadCrumb(breadcrumbGenerator({
                    link: "/",
                    label: categoryName
                  }).cmsPage)
                  : formatBreadCrumb(breadcrumbGenerator().productlist)
                }
              ></BreadCrumb>
            </Col>
          </Row>
          {categoryCMS && (
            <div className="page-builder">
              <PageBuilder html={categoryCMS} />
            </div>
          )}
          {/* } */}
          {errorType &&
          errorType?.isProductFetched &&
          !errorType?.isProductError &&
          categoryDisplayMode !== "PAGE" &&
          !cmsLoading ? (
            <>
              {/* {errorType &&
              (errorType?.isCategoryError || errorType?.isProductError || errorType?.isBrandError) ? < ></> : */}
              <Row>
                {categoryList &&
                categoryList.categories &&
                categoryList.categories.length ? (
                  <Col md={12}>
                    <ProductRangeContainer
                      selectedFilter={selectedFilter}
                      categoryList={categoryList.categories}
                      hide={showComp}
                      handleSelected={handleRangeChange}
                    />
                  </Col>
                ) : (
                  ""
                )}
              </Row>
              {/*  }  */}
              <Row>
                <Col md={12}>
                  <BrowseContainer
                    isDeal={false}
                    hide={showComp}
                    selectionFlag={
                      filteredCategory &&
                      Object.keys(filteredCategory.length !== 0)
                    }
                    heading={pageHeading}
                    shortDescription={
                      filteredCategory && filteredCategory.short_description
                        ? filteredCategory.short_description
                        : labels.lbl_filter_text
                    }
                    filterButton={
                      <ButtonGroup
                        headingName="Filter Products"
                        toggleComps={(val) => {
                          toggleHandler(val);
                        }}
                        noShadow={true}
                        hide={showComp}
                        selectedSortVal={sortProductsBy}
                      />
                    }
                    // containerStyling="browse-bar-tablet-styling"
                  />
                </Col>
              </Row>
              {isEligible() && !showComp && (
                <>
                  <Row>
                    <Col>
                      <UpgradeCheckBar
                        type="info"
                        className="ecom-upgrade-banner products-upgrade-banner"
                        message={
                          labels.product_affordability.lbl_available_products
                        }
                      />
                    </Col>
                  </Row>
                  <Row className="d-block d-lg-none">
                    <Col>
                      <AffordabilityFilterToggle
                        id="chk_qualify_products"
                        checkboxLabel={labels.product_affordability.lbl_qualify}
                        checkboxSubtext={props?.upgrade?.creditFilters?.message}
                        handleCheck={handleShowQualifyProducts}
                        check={showQualifyProducts}
                      />
                    </Col>
                  </Row>
                </>
              )}

              <CustomContainer>
                {!showComp && (
                  <CustomContainer className="filter-btn-group filter-btn-group-for-mobile">
                    <Row>
                      <Col md={12} className="spacing">
                        <ButtonGroup
                          headingName="Filter Products"
                          toggleComps={(val) => {
                            toggleHandler(val);
                          }}
                          noShadow={true}
                          hide={showComp}
                          selectedSortVal={
                            sortProductsBy !== ""
                              ? sortProductsBy
                              : labels.sortKeys.lbl_recommended
                          }
                        />
                      </Col>
                    </Row>
                  </CustomContainer>
                )}
              </CustomContainer>

              <CustomContainer className="d-none d-lg-block">
                <Row>
                  <Col lg={3} xl={3}>
                    {isEligible() && (
                      <AffordabilityFilterToggle
                        id="chk_qualify_products_desktop"
                        checkboxLabel={labels.product_affordability.lbl_qualify}
                        checkboxSubtext={props?.upgrade?.creditFilters?.message}
                        handleCheck={handleShowQualifyProducts}
                        check={showQualifyProducts}
                      />
                    )}
                    <SearchContainer
                      errorType={errorType}
                      brands={allBrands}
                      promotions={allPromotions}
                      selectedSubCategories={selectedFilter.selectedSubCategory}
                      selectedCategory={
                        selectedFilter.selectedCategory ||
                        selectedFilter.selectedProductRange
                      }
                      handleSelectedCategory={handleSelectedCategory}
                      categoriesList={
                        showComp ? categoryList : filteredCategories
                      }
                      selectedFilter={selectedFilter}
                      priceValue={priceValue}
                      priceType={priceType}
                      valueRange={getValueRange()}
                      missingValueRange={getMissingValueRange()}
                      showQualifyProducts={isEligible() && showQualifyProducts}
                      onBrandChange={handleBrandChange}
                      onPromotionChange={handlePromotionChange}
                      onPriceTypeChange={handlePriceTypeChange}
                      onPriceChange={handlePriceChange}
                      onFilterReset={handleResetFilter}
                      onFilterChange={reloadPageData}
                      setSelectedFilter={setSelectedFilter}
                      maxPrice={maxMonthlyPrice}
                      onResetPrice={() => handleResetFilter("price")}
                    />
                  </Col>
                  {productList &&
                  productList.products &&
                  productList.products.items ? (
                    <Col lg={9} xl={9}>
                      <ProductListContainer
                        errorType={errorType}
                        selectedBrands={selectedFilter.brands}
                        selectedPromotions={selectedFilter.promotions}
                        selectedPrice={getSelectedPriceFilter()}
                        items={productList.products.items}
                        sortBy={sortBy}
                        selectedSortFilter={sortProductsBy}
                        pageInfo={productList.products.page_info}
                        updateCurrentPage={updateCurrentPage}
                        totalItemsCount={productList.products.total_count}
                        selectedSortVal={sortProductsBy}
                        bannerData={bannerData}
                        isMonthly={isMonthly()}
                        isOnceOff={isOnceOff()}
                        setSelectedFilter={setSelectedFilter}
                        selectedCategory={
                          selectedFilter.selectedCategory ||
                          selectedFilter.selectedProductRange
                        }
                        showQualifyProducts={
                          isEligible() && showQualifyProducts
                        }
                        onFilterReset={handleResetFilter}
                        onFilterChange={reloadPageData}
                        onBrandChange={handleBrandChange}
                        onPromotionChange={handlePromotionChange}
                        onResetPrice={() => handleResetFilter("price")}
                      />
                    </Col>
                  ) : (
                    <Col></Col>
                  )}
                </Row>
              </CustomContainer>
              <CustomContainer className="spacing-top spacing-bottom d-block d-lg-none ">
                <Row>
                  <Col
                    lg={3}
                    xl={3}
                    className={featureSelected === "filter" && "override"}
                  >
                    {featureSelected === "filter" && (
                      <SearchContainer
                        errorType={errorType}
                        className="nav-gutter"
                        selectedFilter={selectedFilter}
                        hide={showComp}
                        show={changeState}
                        brands={allBrands}
                        promotions={allPromotions}
                        selectedCategory={
                          selectedFilter.selectedCategory ||
                          selectedFilter.selectedProductRange
                        }
                        categoriesList={
                          showComp ? categoryList : filteredCategories
                        }
                        handleSelectedCategory={handleSelectedCategory}
                        priceValue={priceValue}
                        priceType={priceType}
                        valueRange={getValueRange()}
                        missingValueRange={getMissingValueRange()}
                        showQualifyProducts={
                          isEligible() && showQualifyProducts
                        }
                        onBrandChange={handleBrandChange}
                        onPromotionChange={handlePromotionChange}
                        onPriceTypeChange={handlePriceTypeChange}
                        onPriceChange={handlePriceChange}
                        onFilterReset={handleResetFilter}
                        onFilterChange={reloadPageData}
                        setSelectedFilter={setSelectedFilter}
                        maxPrice={maxMonthlyPrice}
                        handleApplyFilter={handleApplyFilter}
                        getSelectedBrands={getSelectedBrands}
                        getSelectedPromotion={getSelectedPromotion}
                        getPriceType={getPriceType}
                        getSelectedPrice={getSelectedPrice}
                        setPriceType={() => setPriceType("")}
                        setPriceValue={() =>
                          setPriceValue({
                            minValue: 0,
                            maxValue: FIXED.MAX_ONCE_OF,
                          })
                        }
                      />
                    )}
                  </Col>

                  {productList &&
                  productList.products &&
                  productList.products.items ? (
                    <Col lg={9} xl={9} className="product-list-gutter">
                      <ProductListContainer
                        errorType={errorType}
                        selectedBrands={selectedFilter.brands}
                        selectedPromotions={selectedFilter.promotions}
                        selectedPrice={getSelectedPriceFilter()}
                        items={productList.products.items}
                        hide={showComp}
                        sortBy={sortBy}
                        selectedSortFilter={sortProductsBy}
                        show={changeState}
                        featureSelected={featureSelected}
                        pageInfo={productList.products.page_info}
                        totalItemsCount={productList.products.total_count}
                        updateCurrentPage={updateCurrentPage}
                        selectedSortVal={sortProductsBy}
                        bannerData={bannerData}
                        isMonthly={isMonthly()}
                        isOnceOff={isOnceOff()}
                        setSelectedFilter={setSelectedFilter}
                        selectedCategory={
                          selectedFilter.selectedCategory ||
                          selectedFilter.selectedProductRange
                        }
                        showQualifyProducts={
                          isEligible() && showQualifyProducts
                        }
                        onFilterReset={handleResetFilter}
                        onFilterChange={reloadPageData}
                        onBrandChange={handleBrandChange}
                        onPromotionChange={handlePromotionChange}
                        onResetPrice={() => handleResetFilter("price")}
                      />
                    </Col>
                  ) : (
                    ""
                  )}
                </Row>
              </CustomContainer>
            </>
          ) : (
            <CustomContainer className="error-container">
              {errorType?.isProductError && !cmsLoading && productListLoaded.current && isPageUpdated ? (
                <ErrorCard errorMsg={errorMessages} fullWidth={1} />
              ) : (
                ""
              )}
            </CustomContainer>
          )}
        </Container>
        {!props?.hidePromo &&
        props?.sections?.length &&
        productList &&
        productList.products &&
        productList.products.items ? (
          <CustomContainer className="deal-promotion">
            {sections.map((component, index) =>
              renderComponent(component, index)
            )}
          </CustomContainer>
        ) : (
          <CustomContainer className="pb-l" />
        )}

        <StickyBottomContainer hide={showComp} />
      </CustomContainer>
    </>
  );
};

ProductListPage.propTypes = {
  gridId: PropTypes.any,
  userLoggedIn: PropTypes.bool,
  profileData: PropTypes.any,
  isUserLoggedIn: PropTypes.bool,
  profileLoading: PropTypes.bool,
  productList: PropTypes.any,
  categoryList: PropTypes.object,
  filterValues: PropTypes.object,
  selectedFilter: PropTypes.any,
  productCompareList: PropTypes.array,
  sections: PropTypes.array,
  upgrade: PropTypes.object,
  hidePromo: PropTypes.bool,
  defaultCategoryId: PropTypes.any,
  dealCategoryId: PropTypes.any,
  getFilterProductList: PropTypes.func,
  removeCompareProducts: PropTypes.func,
  displayHideUpgradeModal: PropTypes.func,
  fetchCreditFilters: PropTypes.func,
  updateUpgradeRedirect: PropTypes.func,
  displayHideUpgradeTopbanner: PropTypes.func,
  updateProductGridReset: PropTypes.func,
  id: PropTypes.string,
  toggleFilters: PropTypes.func,
  previewMode: PropTypes.bool,
};

ProductListPage.defaultProps = {
  userLoggedIn: false,
};

export const getServerSideProps = async ({ query, resolvedUrl }) => {
  const selectedFilter = await parseFilterQuery(
    decodeURIComponent(resolvedUrl)
  );

  let categoryId = k8sConfig.get("category.categoryid");
  let dealCategoryId = k8sConfig.get("category.dealcategoryid");

  let id = k8sConfig.get("products.productGridId");
  let previewMode = query?.previewMode === "on";
  return {
    props: {
      selectedFilter,
      // sections: promotionData?.sections || [],
      // metadata: promotionData?.seoMetadata || {},
      defaultCategoryId: categoryId,
      dealCategoryId: dealCategoryId,
      previewMode,
      id,
    },
  };
};

const mapStateToProps = (state) => ({
  hidePromo: state.displayHideFooter.hideFooter,
  profileData: state.navDetails.profileData,
  userLoggedIn: state.navDetails.isUserLoggedIn,
  profileLoading: state.navDetails.isProfileLoading,
  upgrade: state.upgrade,
});

export default connect(mapStateToProps, {
  removeCompareProducts,
  displayHideUpgradeModal,
  fetchCreditFilters,
  updateUpgradeRedirect,
  displayHideUpgradeTopbanner,
  updateProductGridReset,
  toggleFilters,
})(withRouter(ProductListPage));
